import React, { useState } from 'react';
import {
  ChevronLeft,
  Plus,
  Search,
  Calendar,
  Edit2,
  Trash2,
  Image as ImageIcon,
  Bold,
  Italic,
  Underline,
  Link,
  List,
  ListOrdered,
  Type,
  Paperclip,
  X,
  ChevronDown,
  RotateCcw,
  Check,
  Smartphone,
} from 'lucide-react';

export interface NewsItem {
  id: string;
  type: 'urgent' | 'general';
  title: string;
  description: string;
  content: string;
  coverImage?: string;
  additionalImages?: string[];
  attachedFiles?: string[];
  author: string;
  postedAt: string;
  scheduledAt?: string;
  isDraft: boolean;
  status: 'active' | 'cancelled';
  language: 'th' | 'en';
}

const INITIAL_NEWS: NewsItem[] = [
  // Urgent News (ข่าวด่วน)
  {
    id: 'urg-1',
    type: 'urgent',
    title: 'B51ตั้งเวลาด่วน',
    description: 'B51ตั้งเวลาด่วน1',
    content: 'ประกาศแจ้งเตือนด่วนเรื่องการปิดระบบจ่ายน้ำประปาชั่วคราวเพื่อซ่อมแซมท่อเมนหลัก',
    author: 'Silverman support',
    postedAt: '19/03/2024 - 18:33 น.',
    scheduledAt: '19/03/2024 - 18:36 น.',
    isDraft: false,
    status: 'active',
    language: 'th',
  },
  {
    id: 'urg-2',
    type: 'urgent',
    title: 'B51ข่าว',
    description: 'B51',
    content: 'ประกาศด่วนเรื่องสภาพอากาศและมาตรการรับมือพายุฤดูร้อน',
    author: 'Silverman support',
    postedAt: '19/03/2024 - 18:28 น.',
    scheduledAt: '',
    isDraft: false,
    status: 'active',
    language: 'th',
  },
  {
    id: 'urg-3',
    type: 'urgent',
    title: 'B52',
    description: 'B52',
    content: 'แจ้งเหตุฉุกเฉินระบบไฟฟ้าส่องสว่างซอย 3 กำลังดำเนินการแก้ไข',
    author: 'Silverman support',
    postedAt: '15/03/2024 - 16:03 น.',
    scheduledAt: '',
    isDraft: false,
    status: 'active',
    language: 'th',
  },
  {
    id: 'urg-4',
    type: 'urgent',
    title: 'B209ขดบร',
    description: '123แกนดนกยงยพยดน',
    content: 'เนื้อหาฉบับร่างสำหรับการเตรียมความพร้อมงานประชุมด่วน',
    author: 'Silverman support',
    postedAt: '11/03/2024 - 14:34 น.',
    scheduledAt: '',
    isDraft: true,
    status: 'active',
    language: 'th',
  },
  {
    id: 'urg-5',
    type: 'urgent',
    title: 'B209ขตว',
    description: '123456',
    content: 'ทดสอบการส่งข่าวด่วนตามช่วงเวลาที่กำหนด',
    author: 'Silverman support',
    postedAt: '11/03/2024 - 14:31 น.',
    scheduledAt: '11/03/2024 - 14:33 น.',
    isDraft: false,
    status: 'active',
    language: 'th',
  },

  // General Announcements (ข่าวประชาสัมพันธ์)
  {
    id: 'gen-1',
    type: 'general',
    title: 'B51ตั้งเวลาประชาสัม',
    description: 'B51ตั้งเวลาประชาสัม',
    content: 'แจ้งกำหนดการฉีดพ่นยากันยุงลายและกำจัดลูกน้ำ ประจำเดือนมีนาคม 2567',
    author: 'Silverman support',
    postedAt: '19/03/2024 - 18:32 น.',
    scheduledAt: '19/03/2024 - 18:35 น.',
    isDraft: false,
    status: 'active',
    language: 'th',
  },
  {
    id: 'gen-2',
    type: 'general',
    title: 'B51',
    description: 'ทดสอบ',
    content: 'ขอความร่วมมือลูกบ้านคัดแยกขยะก่อนทิ้งลงในถังพักส่วนกลาง',
    author: 'Silverman support',
    postedAt: '19/03/2024 - 18:26 น.',
    scheduledAt: '',
    isDraft: false,
    status: 'active',
    language: 'th',
  },
  {
    id: 'gen-3',
    type: 'general',
    title: 'TEST19',
    description: 'ลำโพง',
    content: 'แจ้งทดสอบระบบเสียงตามสายส่วนกลางทุกวันเสาร์ เวลา 10:00 น.',
    author: 'Silverman support',
    postedAt: '19/03/2024 - 09:45 น.',
    scheduledAt: '',
    isDraft: false,
    status: 'active',
    language: 'th',
  },
  {
    id: 'gen-4',
    type: 'general',
    title: 'test',
    description: 'ทดสอบ',
    content: 'ข่าวประชาสัมพันธ์ทั่วไปสำหรับเจ้าของร่วมและผู้อยู่อาศัย',
    author: 'Silverman support',
    postedAt: '15/03/2024 - 15:22 น.',
    scheduledAt: '',
    isDraft: false,
    status: 'active',
    language: 'th',
  },
];

interface Props {
  onBackToMenu: () => void;
}

export const AdminNewsManagementView: React.FC<Props> = ({ onBackToMenu }) => {
  const [newsList, setNewsList] = useState<NewsItem[]>(INITIAL_NEWS);
  const [activeTab, setActiveTab] = useState<'urgent' | 'general' | 'cancelled'>('urgent');
  const [isCreating, setIsCreating] = useState(false);
  const [editingItem, setEditingItem] = useState<NewsItem | null>(null);

  // Filter & Search states
  const [searchQuery, setSearchQuery] = useState('');
  const [startDate, setStartDate] = useState('2024-02-29');
  const [endDate, setEndDate] = useState('2024-03-29');
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [batchMenuOpen, setBatchMenuOpen] = useState(false);

  // Form states for Create/Edit
  const [formLang, setFormLang] = useState<'th' | 'en'>('th');
  const [formType, setFormType] = useState<'general' | 'urgent'>('general');
  const [formTitle, setFormTitle] = useState('');
  const [formContent, setFormContent] = useState('');
  const [formCoverImage, setFormCoverImage] = useState<string | null>(null);
  const [formAdditionalImages, setFormAdditionalImages] = useState<string[]>([]);
  const [formAttachedFiles, setFormAttachedFiles] = useState<string[]>([]);
  const [isScheduled, setIsScheduled] = useState(false);
  const [scheduleDateTime, setScheduleDateTime] = useState('2024-03-19T18:35');

  // Filtered items based on active tab and search
  const currentTabItems = newsList.filter((item) => {
    if (activeTab === 'cancelled') {
      return item.status === 'cancelled';
    }
    if (item.status === 'cancelled') return false;
    return item.type === activeTab;
  });

  const filteredItems = currentTabItems.filter((item) => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.author.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearch;
  });

  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedIds(filteredItems.map((item) => item.id));
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectRow = (id: string) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleDeleteItem = (id: string) => {
    if (confirm('คุณต้องการยกเลิก/ลบข่าวนี้ใช่หรือไม่?')) {
      setNewsList((prev) =>
        prev.map((item) => (item.id === id ? { ...item, status: 'cancelled' } : item))
      );
      setSelectedIds((prev) => prev.filter((i) => i !== id));
    }
  };

  const handleRestoreItem = (id: string) => {
    setNewsList((prev) =>
      prev.map((item) => (item.id === id ? { ...item, status: 'active' } : item))
    );
  };

  const handlePermanentDelete = (id: string) => {
    if (confirm('ต้องการลบรายการนี้ออกจากระบบอย่างถาวรใช่หรือไม่?')) {
      setNewsList((prev) => prev.filter((item) => item.id !== id));
    }
  };

  const handleBatchDelete = () => {
    if (selectedIds.length === 0) return;
    if (confirm(`คุณต้องการยกเลิกข่าวที่เลือกจำนวน ${selectedIds.length} รายการใช่หรือไม่?`)) {
      setNewsList((prev) =>
        prev.map((item) => (selectedIds.includes(item.id) ? { ...item, status: 'cancelled' } : item))
      );
      setSelectedIds([]);
      setBatchMenuOpen(false);
    }
  };

  const handleOpenCreate = () => {
    setEditingItem(null);
    setFormType(activeTab === 'urgent' ? 'urgent' : 'general');
    setFormTitle('');
    setFormContent('');
    setFormCoverImage(null);
    setFormAdditionalImages([]);
    setFormAttachedFiles([]);
    setIsScheduled(false);
    setIsCreating(true);
  };

  const handleOpenEdit = (item: NewsItem) => {
    setEditingItem(item);
    setFormType(item.type);
    setFormTitle(item.title);
    setFormContent(item.content || item.description);
    setFormCoverImage(item.coverImage || null);
    setFormAdditionalImages(item.additionalImages || []);
    setFormAttachedFiles(item.attachedFiles || []);
    setIsScheduled(!!item.scheduledAt);
    setIsCreating(true);
  };

  const handleSaveForm = (isDraftSave: boolean = false) => {
    if (!formTitle.trim()) {
      alert('กรุณากรอกหัวข้อข่าว');
      return;
    }

    const now = new Date();
    const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${now.getFullYear() + 543} - ${now
      .getHours()
      .toString()
      .padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')} น.`;

    if (editingItem) {
      // Update existing
      setNewsList((prev) =>
        prev.map((item) =>
          item.id === editingItem.id
            ? {
                ...item,
                type: formType,
                title: formTitle,
                description: formTitle,
                content: formContent,
                coverImage: formCoverImage || undefined,
                additionalImages: formAdditionalImages,
                attachedFiles: formAttachedFiles,
                isDraft: isDraftSave,
                scheduledAt: isScheduled ? '19/03/2024 - 18:36 น.' : undefined,
              }
            : item
        )
      );
    } else {
      // Create new
      const newItem: NewsItem = {
        id: `news-${Date.now()}`,
        type: formType,
        title: formTitle,
        description: formTitle,
        content: formContent,
        coverImage: formCoverImage || undefined,
        additionalImages: formAdditionalImages,
        attachedFiles: formAttachedFiles,
        author: 'Silverman support',
        postedAt: formattedDate,
        scheduledAt: isScheduled ? '19/03/2024 - 18:36 น.' : undefined,
        isDraft: isDraftSave,
        status: 'active',
        language: formLang,
      };
      setNewsList((prev) => [newItem, ...prev]);
    }

    setIsCreating(false);
    setEditingItem(null);
  };

  // Mock upload handlers
  const handleCoverUpload = () => {
    const mockImage =
      'https://images.unsplash.com/photo-1541888946425-d0fbb186156a?auto=format&fit=crop&w=800&q=80';
    setFormCoverImage(mockImage);
  };

  const handleAddSubImage = () => {
    const mockImage =
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80';
    setFormAdditionalImages((prev) => [...prev, mockImage]);
  };

  const handleAttachPdf = () => {
    setFormAttachedFiles((prev) => [...prev, 'เอกสารประกาศ_นิติบุคคล_2567.pdf']);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-2xs min-h-[80vh] flex flex-col font-sans">
      {/* ========================================================================= */}
      {/* 1. CREATE / EDIT NEWS SCREEN (Exact match to Image 6 & 7) */}
      {/* ========================================================================= */}
      {isCreating ? (
        <div className="p-6 space-y-6">
          {/* Header */}
          <div className="flex items-center gap-3 border-b border-slate-100 pb-4">
            <button
              type="button"
              onClick={() => setIsCreating(false)}
              className="w-8 h-8 rounded-full border border-slate-300 hover:bg-slate-100 flex items-center justify-center text-slate-600 transition-colors cursor-pointer"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <h1 className="text-xl font-bold text-slate-900">
              {editingItem ? 'แก้ไขข่าวสาร' : 'เพิ่มข่าวสาร'}
            </h1>
          </div>

          {/* Form Layout: 2 Columns */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            {/* Left Column: Form Fields (7 Cols) */}
            <div className="lg:col-span-7 space-y-5">
              {/* Language Tabs */}
              <div className="flex items-center gap-1 border-b border-slate-200">
                <button
                  type="button"
                  onClick={() => setFormLang('th')}
                  className={`px-4 py-2 text-xs font-bold border-b-2 transition-colors ${
                    formLang === 'th'
                      ? 'border-blue-600 text-blue-600 bg-blue-50/50'
                      : 'border-transparent text-slate-500 hover:text-slate-800'
                  }`}
                >
                  TH
                </button>
                <button
                  type="button"
                  onClick={() => setFormLang('en')}
                  className={`px-4 py-2 text-xs font-bold border-b-2 transition-colors ${
                    formLang === 'en'
                      ? 'border-blue-600 text-blue-600 bg-blue-50/50'
                      : 'border-transparent text-slate-500 hover:text-slate-800'
                  }`}
                >
                  EN
                </button>
              </div>

              {/* ประเภทข่าว (Radio buttons) */}
              <div className="space-y-2">
                <label className="text-xs font-bold text-slate-800 block">ประเภทข่าว</label>
                <div className="flex items-center gap-6 text-xs text-slate-700">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="newsType"
                      value="general"
                      checked={formType === 'general'}
                      onChange={() => setFormType('general')}
                      className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                    />
                    <span>ข่าวประชาสัมพันธ์</span>
                  </label>

                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="newsType"
                      value="urgent"
                      checked={formType === 'urgent'}
                      onChange={() => setFormType('urgent')}
                      className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                    />
                    <span>ข่าวด่วน</span>
                  </label>
                </div>
              </div>

              {/* หัวข้อ * */}
              <div className="space-y-1.5">
                <label className="text-xs font-bold text-slate-800 block">
                  หัวข้อ <span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="เช่น ประกาศดับไฟ"
                  value={formTitle}
                  onChange={(e) => setFormTitle(e.target.value)}
                  className="w-full p-2.5 text-xs bg-white border border-slate-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 text-slate-800"
                />
              </div>

              {/* ภาพหัวข้อเรื่อง * */}
              <div className="space-y-1.5">
                <label className="text-xs font-bold text-slate-800 block">
                  ภาพหัวข้อเรื่อง <span className="text-rose-500">*</span>{' '}
                  <span className="text-[11px] font-normal text-rose-400">
                    * ไฟล์ภาพ jpg,png เท่านั้น ขนาดไม่เกิน 2000 x 2000 พิกเซล
                  </span>
                </label>

                {formCoverImage ? (
                  <div className="relative border border-slate-200 rounded-xl overflow-hidden group max-w-md">
                    <img
                      src={formCoverImage}
                      alt="Cover"
                      className="w-full h-44 object-cover"
                      referrerPolicy="no-referrer"
                    />
                    <button
                      type="button"
                      onClick={() => setFormCoverImage(null)}
                      className="absolute top-2 right-2 p-1.5 rounded-full bg-slate-900/70 text-white hover:bg-rose-600 transition-colors"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ) : (
                  <div
                    onClick={handleCoverUpload}
                    className="border-2 border-dashed border-slate-200 hover:border-blue-400 rounded-xl p-8 flex flex-col items-center justify-center gap-2 cursor-pointer bg-slate-50/50 hover:bg-blue-50/20 transition-all text-slate-400 hover:text-blue-600"
                  >
                    <ImageIcon className="w-10 h-10 stroke-[1.2]" />
                    <span className="text-xs font-medium text-slate-600">คลิกเพื่อเลือกรูปภาพ</span>
                  </div>
                )}
              </div>

              {/* เนื้อหา * */}
              <div className="space-y-1.5">
                <label className="text-xs font-bold text-slate-800 block">
                  เนื้อหา <span className="text-rose-500">*</span>
                </label>

                {/* WYSIWYG Toolbar */}
                <div className="border border-slate-200 rounded-xl overflow-hidden bg-white">
                  <div className="p-2 border-b border-slate-200 bg-slate-50/80 flex items-center gap-2 flex-wrap text-slate-600 text-xs">
                    <div className="flex items-center gap-1 border-r border-slate-200 pr-2">
                      <span className="text-[11px] font-medium">Normal</span>
                      <ChevronDown className="w-3.5 h-3.5 text-slate-400" />
                    </div>
                    <button
                      type="button"
                      className="p-1 hover:bg-slate-200 rounded text-slate-700"
                      title="Bold"
                    >
                      <Bold className="w-3.5 h-3.5" />
                    </button>
                    <button
                      type="button"
                      className="p-1 hover:bg-slate-200 rounded text-slate-700"
                      title="Italic"
                    >
                      <Italic className="w-3.5 h-3.5" />
                    </button>
                    <button
                      type="button"
                      className="p-1 hover:bg-slate-200 rounded text-slate-700"
                      title="Underline"
                    >
                      <Underline className="w-3.5 h-3.5" />
                    </button>
                    <button
                      type="button"
                      className="p-1 hover:bg-slate-200 rounded text-slate-700"
                      title="Link"
                    >
                      <Link className="w-3.5 h-3.5" />
                    </button>
                    <button
                      type="button"
                      className="p-1 hover:bg-slate-200 rounded text-slate-700"
                      title="Bullet List"
                    >
                      <List className="w-3.5 h-3.5" />
                    </button>
                    <button
                      type="button"
                      className="p-1 hover:bg-slate-200 rounded text-slate-700"
                      title="Numbered List"
                    >
                      <ListOrdered className="w-3.5 h-3.5" />
                    </button>
                    <button
                      type="button"
                      className="p-1 hover:bg-slate-200 rounded text-slate-700"
                      title="Format"
                    >
                      <Type className="w-3.5 h-3.5" />
                    </button>
                  </div>
                  <textarea
                    rows={6}
                    placeholder="พิมพ์เนื้อหาข่าวสารที่นี่..."
                    value={formContent}
                    onChange={(e) => setFormContent(e.target.value)}
                    className="w-full p-3 text-xs bg-white focus:outline-none text-slate-800 resize-y"
                  />
                </div>
              </div>

              {/* แนบรูปภาพเพิ่มเติม */}
              <div className="space-y-1.5">
                <label className="text-xs font-bold text-slate-800 block">
                  แนบรูปภาพเพิ่มเติม{' '}
                  <span className="text-[11px] font-normal text-rose-400">
                    ไฟล์ภาพ jpg,png เท่านั้น ขนาดไม่เกิน 2000 x 2000 พิกเซล
                  </span>
                </label>

                <div className="flex items-center gap-3 flex-wrap">
                  {formAdditionalImages.map((img, index) => (
                    <div
                      key={index}
                      className="relative w-16 h-16 rounded-xl border border-slate-200 overflow-hidden"
                    >
                      <img
                        src={img}
                        alt={`Sub ${index}`}
                        className="w-full h-full object-cover"
                        referrerPolicy="no-referrer"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setFormAdditionalImages((prev) => prev.filter((_, i) => i !== index))
                        }
                        className="absolute top-1 right-1 p-0.5 rounded-full bg-slate-900/80 text-white"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={handleAddSubImage}
                    className="w-16 h-16 rounded-xl border-2 border-dashed border-slate-200 hover:border-blue-400 bg-slate-50 flex items-center justify-center text-slate-400 hover:text-blue-600 transition-colors cursor-pointer"
                  >
                    <Plus className="w-5 h-5" />
                  </button>
                </div>
              </div>

              {/* ไฟล์เพิ่มเติม */}
              <div className="space-y-1.5 pt-2">
                <label className="text-xs font-bold text-slate-800 block">ไฟล์เพิ่มเติม</label>
                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    onClick={handleAttachPdf}
                    className="px-3 py-1.5 rounded-lg border border-slate-300 hover:bg-slate-50 text-xs font-medium text-slate-700 flex items-center gap-1.5 cursor-pointer shadow-2xs"
                  >
                    <Paperclip className="w-3.5 h-3.5" /> แนบไฟล์
                  </button>
                  <span className="text-[10px] text-slate-400">
                    Support File Just .PDF Only and File Not Over 10 MB (Max 3 Image Only)
                  </span>
                </div>

                {formAttachedFiles.length > 0 && (
                  <div className="space-y-1 pt-1">
                    {formAttachedFiles.map((file, i) => (
                      <div
                        key={i}
                        className="flex items-center justify-between text-xs bg-slate-50 p-2 rounded-lg border border-slate-200"
                      >
                        <span className="text-slate-700 flex items-center gap-1.5">
                          📄 {file}
                        </span>
                        <button
                          type="button"
                          onClick={() =>
                            setFormAttachedFiles((prev) => prev.filter((_, idx) => idx !== i))
                          }
                          className="text-rose-500 hover:text-rose-700"
                        >
                          <X className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Right Column: Posting Options & Mobile Device Mockup Live Preview (5 Cols) */}
            <div className="lg:col-span-5 space-y-6">
              {/* Card: ตัวเลือกการโพสต์ */}
              <div className="bg-white rounded-2xl border border-slate-200 p-5 shadow-2xs space-y-4">
                <h3 className="text-xs font-bold text-slate-800 border-b border-slate-100 pb-2">
                  ตัวเลือกการโพสต์
                </h3>

                <div className="space-y-3">
                  <label className="flex items-center gap-2 cursor-pointer text-xs text-slate-700">
                    <input
                      type="checkbox"
                      checked={isScheduled}
                      onChange={(e) => setIsScheduled(e.target.checked)}
                      className="rounded text-blue-600 focus:ring-blue-500"
                    />
                    <span>ตั้งเวลาที่จะส่งข่าวประกาศ</span>
                  </label>

                  {isScheduled && (
                    <div className="p-3 bg-slate-50 rounded-xl border border-slate-200 space-y-1.5 animate-in fade-in">
                      <label className="text-[11px] font-medium text-slate-600 block">
                        กำหนดวันและเวลาที่เผยแพร่:
                      </label>
                      <input
                        type="datetime-local"
                        value={scheduleDateTime}
                        onChange={(e) => setScheduleDateTime(e.target.value)}
                        className="w-full p-2 text-xs bg-white border border-slate-200 rounded-lg text-slate-800"
                      />
                    </div>
                  )}
                </div>

                <div className="flex items-center gap-3 pt-2">
                  <button
                    type="button"
                    onClick={() => handleSaveForm(true)}
                    className="flex-1 py-2.5 px-4 rounded-xl border border-blue-600 text-blue-600 hover:bg-blue-50 text-xs font-bold transition-colors cursor-pointer"
                  >
                    บันทึกแบบร่าง
                  </button>
                  <button
                    type="button"
                    onClick={() => handleSaveForm(false)}
                    className="flex-1 py-2.5 px-4 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold shadow-xs transition-colors cursor-pointer"
                  >
                    ตกลง
                  </button>
                </div>
              </div>

              {/* Card: ตัวอย่างการแสดงผล (Mobile Mockup Preview matching Image 6 & 7) */}
              <div className="flex flex-col items-center space-y-3">
                <h3 className="text-xs font-bold text-slate-700">ตัวอย่างการแสดงผล</h3>

                {/* Smartphone Device Frame */}
                <div className="w-[280px] sm:w-[300px] h-[520px] bg-slate-950 rounded-[40px] p-3 shadow-2xl border-4 border-slate-800 relative flex flex-col">
                  {/* Speaker notch */}
                  <div className="w-24 h-4 bg-slate-900 rounded-full mx-auto mb-2 shrink-0 flex items-center justify-center">
                    <div className="w-8 h-1 bg-slate-700 rounded-full" />
                  </div>

                  {/* Mobile Screen Container */}
                  <div className="w-full h-full bg-white rounded-[28px] overflow-hidden flex flex-col relative text-slate-900 shadow-inner">
                    {/* App Header */}
                    <div className="bg-slate-900 text-white px-4 py-2.5 text-[11px] font-bold flex items-center justify-between shrink-0">
                      <span>นราวดี อิลิแกนซ์</span>
                      <span className="text-[9px] text-blue-400">9:41 AM</span>
                    </div>

                    {/* App Article Body */}
                    <div className="flex-1 overflow-y-auto p-4 space-y-3">
                      {/* Cover Photo */}
                      {formCoverImage ? (
                        <img
                          src={formCoverImage}
                          alt="Mobile Cover"
                          className="w-full h-32 object-cover rounded-xl shadow-xs"
                          referrerPolicy="no-referrer"
                        />
                      ) : (
                        <div className="w-full h-24 bg-slate-100 rounded-xl flex items-center justify-center text-slate-300">
                          <ImageIcon className="w-8 h-8 stroke-[1.5]" />
                        </div>
                      )}

                      {/* Badge & Date */}
                      <div className="flex items-center justify-between text-[9px]">
                        <span
                          className={`px-2 py-0.5 rounded-full font-bold ${
                            formType === 'urgent'
                              ? 'bg-rose-100 text-rose-800'
                              : 'bg-blue-100 text-blue-800'
                          }`}
                        >
                          {formType === 'urgent' ? 'ข่าวด่วน' : 'ข่าวประชาสัมพันธ์'}
                        </span>
                        <span className="text-slate-400">วันนี้</span>
                      </div>

                      {/* Title */}
                      <h4 className="font-bold text-xs leading-snug text-slate-900 break-words">
                        {formTitle || 'ประกาศดับไฟ'}
                      </h4>

                      {/* Content */}
                      <p className="text-[11px] text-slate-600 leading-relaxed break-words whitespace-pre-line">
                        {formContent || formTitle || 'ประกาศดับไฟ'}
                      </p>

                      {/* Attached images preview */}
                      {formAdditionalImages.length > 0 && (
                        <div className="grid grid-cols-2 gap-1.5 pt-2">
                          {formAdditionalImages.map((sub, sIdx) => (
                            <img
                              key={sIdx}
                              src={sub}
                              alt="Sub"
                              className="w-full h-16 object-cover rounded-lg"
                              referrerPolicy="no-referrer"
                            />
                          ))}
                        </div>
                      )}

                      {/* Attached Files Badge */}
                      {formAttachedFiles.length > 0 && (
                        <div className="p-2 bg-slate-50 border border-slate-200 rounded-lg text-[9px] text-blue-600 font-medium">
                          📎 มีไฟล์แนบ PDF ({formAttachedFiles.length} ไฟล์)
                        </div>
                      )}
                    </div>

                    {/* Mobile Home Bar */}
                    <div className="w-20 h-1 bg-slate-300 rounded-full mx-auto my-1.5 shrink-0" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        /* ========================================================================= */
        /* 2. NEWS LIST SCREEN (Exact match to Image 2, 3, 4, 5) */
        /* ========================================================================= */
        <div className="p-5 sm:p-6 space-y-5">
          {/* Header Row */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={onBackToMenu}
                className="w-8 h-8 rounded-full border border-slate-300 hover:bg-slate-100 flex items-center justify-center text-slate-600 transition-colors cursor-pointer"
                title="กลับสู่เมนูงานเจ้าของร่วม/สมาชิก"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <h1 className="text-xl font-bold text-slate-900">ข่าวประชาสัมพันธ์</h1>
            </div>

            <button
              type="button"
              onClick={handleOpenCreate}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-xs font-bold flex items-center gap-1.5 shadow-xs transition-colors cursor-pointer"
            >
              <Plus className="w-4 h-4" /> เพิ่มข่าว
            </button>
          </div>

          {/* 3 Main Tabs: ข่าวด่วน | ข่าวประชาสัมพันธ์ | รายการที่ยกเลิก */}
          <div className="flex items-center gap-8 border-b border-slate-200 text-xs">
            <button
              type="button"
              onClick={() => {
                setActiveTab('urgent');
                setSelectedIds([]);
              }}
              className={`pb-3 font-bold transition-all relative cursor-pointer ${
                activeTab === 'urgent'
                  ? 'text-blue-600'
                  : 'text-slate-500 hover:text-slate-800 font-medium'
              }`}
            >
              ข่าวด่วน
              {activeTab === 'urgent' && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full" />
              )}
            </button>

            <button
              type="button"
              onClick={() => {
                setActiveTab('general');
                setSelectedIds([]);
              }}
              className={`pb-3 font-bold transition-all relative cursor-pointer ${
                activeTab === 'general'
                  ? 'text-blue-600'
                  : 'text-slate-500 hover:text-slate-800 font-medium'
              }`}
            >
              ข่าวประชาสัมพันธ์
              {activeTab === 'general' && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full" />
              )}
            </button>

            <button
              type="button"
              onClick={() => {
                setActiveTab('cancelled');
                setSelectedIds([]);
              }}
              className={`pb-3 font-bold transition-all relative cursor-pointer ${
                activeTab === 'cancelled'
                  ? 'text-blue-600'
                  : 'text-slate-500 hover:text-slate-800 font-medium'
              }`}
            >
              รายการที่ยกเลิก
              {activeTab === 'cancelled' && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full" />
              )}
            </button>
          </div>

          {/* Action & Filter Bar matching Image 2 */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 pt-1">
            {/* Batch Action Dropdown */}
            <div className="relative w-full md:w-auto">
              <button
                type="button"
                onClick={() => setBatchMenuOpen(!batchMenuOpen)}
                className="px-3.5 py-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-50 text-xs font-medium text-slate-700 flex items-center justify-between gap-2 w-full md:w-auto cursor-pointer shadow-2xs"
              >
                <span>จัดการหลายรายการ</span>
                <ChevronDown className="w-3.5 h-3.5 text-slate-500" />
              </button>

              {batchMenuOpen && (
                <div className="absolute left-0 mt-1 w-48 bg-white border border-slate-200 rounded-xl shadow-lg p-1.5 z-20 space-y-1 text-xs">
                  <button
                    type="button"
                    onClick={handleBatchDelete}
                    disabled={selectedIds.length === 0}
                    className={`w-full text-left px-3 py-1.5 rounded-lg font-medium flex items-center gap-2 ${
                      selectedIds.length > 0
                        ? 'text-rose-600 hover:bg-rose-50 cursor-pointer'
                        : 'text-slate-300 cursor-not-allowed'
                    }`}
                  >
                    <Trash2 className="w-3.5 h-3.5" /> ยกเลิกรายการที่เลือก ({selectedIds.length})
                  </button>
                </div>
              )}
            </div>

            {/* Date filter & Search Box matching Image 2 */}
            <div className="flex items-center gap-2 flex-wrap w-full md:w-auto justify-end text-xs">
              <span className="text-slate-500 whitespace-nowrap">เรียงดูตามวัน</span>

              {/* Start Date */}
              <div className="relative">
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="pl-2.5 pr-2 py-1.5 border border-slate-300 rounded-lg text-xs bg-white text-slate-700 focus:outline-none"
                />
              </div>

              <span className="text-slate-400">ถึง</span>

              {/* End Date */}
              <div className="relative">
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="pl-2.5 pr-2 py-1.5 border border-slate-300 rounded-lg text-xs bg-white text-slate-700 focus:outline-none"
                />
              </div>

              {/* Search input */}
              <div className="relative flex-1 sm:w-48 md:w-56">
                <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="text"
                  placeholder="ค้นหา"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-8 pr-2.5 py-1.5 border border-slate-300 rounded-lg text-xs bg-white text-slate-700 focus:outline-none"
                />
              </div>

              {/* Search button */}
              <button
                type="button"
                onClick={() => {}}
                className="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-xs font-bold transition-colors cursor-pointer"
              >
                ค้นหา
              </button>
            </div>
          </div>

          {/* News Table matching Image 2 & 3 */}
          <div className="border border-slate-200 rounded-xl overflow-hidden shadow-2xs">
            <table className="w-full text-left text-xs">
              <thead className="bg-slate-100/80 text-slate-600 font-semibold border-b border-slate-200">
                <tr>
                  <th className="p-3 w-10 text-center">
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={
                        filteredItems.length > 0 && selectedIds.length === filteredItems.length
                      }
                      className="rounded text-blue-600 focus:ring-blue-500"
                    />
                  </th>
                  <th className="p-3">เรื่อง/คำอธิบาย</th>
                  <th className="p-3">โพสต์โดย</th>
                  <th className="p-3">
                    <div className="flex items-center gap-1 cursor-pointer">
                      <span>วันที่โพสต์</span>
                      <ChevronDown className="w-3 h-3 text-slate-400" />
                    </div>
                  </th>
                  <th className="p-3">วันที่ตั้งเวลาโพสต์</th>
                  <th className="p-3 text-right"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white">
                {filteredItems.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="py-12 text-center text-slate-400">
                      ไม่พบข้อมูลข่าวสารในหมวดหมู่นี้
                    </td>
                  </tr>
                ) : (
                  filteredItems.map((item) => {
                    const isSelected = selectedIds.includes(item.id);
                    return (
                      <tr
                        key={item.id}
                        className={`hover:bg-slate-50/80 transition-colors ${
                          isSelected ? 'bg-blue-50/30' : ''
                        }`}
                      >
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => handleSelectRow(item.id)}
                            className="rounded text-blue-600 focus:ring-blue-500"
                          />
                        </td>

                        <td className="p-3">
                          <div className="flex items-center gap-2">
                            <span
                              onClick={() => handleOpenEdit(item)}
                              className="font-bold text-sky-600 hover:text-sky-700 hover:underline cursor-pointer"
                            >
                              {item.title}
                            </span>
                            {item.isDraft && (
                              <span className="text-[10px] text-rose-500 font-medium">
                                แบบร่าง
                              </span>
                            )}
                          </div>
                          <div className="text-[11px] text-slate-400 mt-0.5">{item.description}</div>
                        </td>

                        <td className="p-3 text-slate-600 font-medium">{item.author}</td>

                        <td className="p-3 text-slate-600 font-mono">{item.postedAt}</td>

                        <td className="p-3 text-slate-600 font-mono">
                          {item.scheduledAt || '-'}
                        </td>

                        <td className="p-3 text-right">
                          <div className="flex items-center justify-end gap-2 text-slate-400">
                            {activeTab === 'cancelled' ? (
                              <>
                                <button
                                  type="button"
                                  onClick={() => handleRestoreItem(item.id)}
                                  title="กู้คืนรายการ"
                                  className="p-1 hover:text-blue-600 transition-colors cursor-pointer"
                                >
                                  <RotateCcw className="w-3.5 h-3.5" />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handlePermanentDelete(item.id)}
                                  title="ลบถาวร"
                                  className="p-1 hover:text-rose-600 transition-colors cursor-pointer"
                                >
                                  <Trash2 className="w-3.5 h-3.5" />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  onClick={() => handleOpenEdit(item)}
                                  title="แก้ไข"
                                  className="p-1 hover:text-blue-600 transition-colors cursor-pointer"
                                >
                                  <Edit2 className="w-3.5 h-3.5" />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDeleteItem(item.id)}
                                  title="ยกเลิก/ลบ"
                                  className="p-1 hover:text-rose-600 transition-colors cursor-pointer"
                                >
                                  <Trash2 className="w-3.5 h-3.5" />
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination & Summary Footer matching Image 4 */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500 pt-2">
            <div className="flex items-center gap-2">
              <select className="border border-slate-300 rounded-lg px-2.5 py-1 text-xs bg-white text-slate-700">
                <option value="10">แสดง 10 รายการ/หน้า</option>
                <option value="25">แสดง 25 รายการ/หน้า</option>
                <option value="50">แสดง 50 รายการ/หน้า</option>
              </select>
            </div>

            <div>
              <span>รายการทั้งหมด {filteredItems.length}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
